module.exports = __webpack_public_path__ + "img/甘肃交通广播_02.99fd7d8f.jpg";